import type { DrawerHotel } from './types'

export function formatDrawerHotelInfo(hotel: DrawerHotel): string {
  const lines: Array<string> = []
  lines.push(`Hotel: ${hotel.name}`)
  if (hotel.location) {
    lines.push(`Location: ${hotel.location}`)
  }
  if (hotel.description) {
    lines.push(`Description: ${hotel.description.substring(0, 500)}${hotel.description.length > 500 ? '...' : ''}`)
  }
  if (hotel.rating) {
    const reviewCount = hotel.reviewsTotal ? ` (${hotel.reviewsTotal} reviews)` : ''
    lines.push(`Rating: ${hotel.rating}/5${reviewCount}`)
  }
  if (hotel.inclusions && hotel.inclusions.length > 0) {
    const inclusionsList = hotel.inclusions.slice(0, 5).map(i => i.description).join(', ')
    lines.push(`Inclusions: ${inclusionsList}`)
  }
  if (hotel.amenities && hotel.amenities.length > 0) {
    const amenitiesList = hotel.amenities.slice(0, 8).map(a => a.name).join(', ')
    lines.push(`Amenities: ${amenitiesList}`)
  }
  lines.push(`Offer ID: ${hotel.offerId}`)
  return lines.join('\n')
}
